export enum TuitionPlanFrequency {
    Once = 'once',
    Annual = 'annual',
    Monthly = 'monthly',
    MonthlyExtended = 'monthly_extended',
    FullScholarship = 'full_scholarship',
    Custom = 'custom', // deprecated
    BiAnnual = 'bi_annual', // deprecated
}

export enum TuitionPlanFrequencySortKey {
    full_scholarship = 0,
    once = 1,
    annual = 2,
    monthly = 3,
    monthly_extended = 4,
    custom = Number.MAX_VALUE, // deprecated
    bi_annual = Number.MAX_VALUE, // deprecated
}

export interface Institution {
    id: string;
    name: string;
}

export type TuitionPlan = {
    id: string;
    baseTuition: number;
    name: string;
    tag: string;
    frequency: TuitionPlanFrequency;
    numIntervals: number | null;
};
